import { cn } from "@/lib/utils";

export type StatCardTone = "default" | "success" | "warning" | "danger";

const VALUE_TONE: Record<StatCardTone, string> = {
  default: "text-ink",
  success: "text-success",
  warning: "text-warning",
  danger: "text-danger",
};

export function StatCard({
  value,
  label,
  hint,
  positiveHint,
  tone = "default",
}: {
  value: string;
  label: string;
  hint?: string | null;
  positiveHint?: boolean;
  tone?: StatCardTone;
}) {
  return (
    <div className="rounded-lg border border-line bg-surface px-5 py-[18px]">
      <div className={cn("text-[28px] font-bold leading-[1.1] tracking-tight", VALUE_TONE[tone])}>{value}</div>
      <div className="mt-1 text-xs text-muted">{label}</div>
      {hint && (
        <div className={`mt-0.5 text-xs ${positiveHint ? "text-success" : "text-muted"}`}>{hint}</div>
      )}
    </div>
  );
}